<template>
  <div class='flex gap-2 items-center'>
    <label class='flex-1'>
      <span class="block text-sm font-medium leading-6 text-gray-900 mb-2" :class='{"sr-only": props.hideLabel}'>
        {{ props.label }} <span class='sr-only'>From</span>
      </span>
      <input type="number" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" v-model='state.from' placeholder='From' :required='props.required' />
    </label>
    <label class='flex-1'>
      <span class="block text-sm font-medium leading-6 text-gray-900 mb-2 opacity-0" :class='{"sr-only": props.hideLabel}'>
        {{ props.label }} <span class='sr-only'>To</span>
      </span>
      <input type="number" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-jananavy-600 sm:text-sm sm:leading-6" v-model='state.to' placeholder='To' :required='props.required' />
    </label>
  </div>
</template>

<script setup>

import { reactive, watch } from 'vue';

import SelectInput from '@/components/inputs/select-input.vue';

const props = defineProps({
  label: String,
  hideLabel: Boolean,
  required: {
    type: Boolean,
    default: false
  }
});

const model = defineModel();

const state = reactive({
  from: model.value?.from || null,
  to: model.value?.to || null
});

watch(model, () => {
  modelDidChange();
});

watch(state, () => {
  stateDidChange();
});

const modelDidChange = () => {
  if (state.from !== model.value?.from) {
    state.from = model.value?.from || null;
  }
  
  if (state.to !== model.value?.to) {
   state.to = model.value?.to || null;
  }
}

const stateDidChange = () => {
  if (model.value?.from !== state.from || model.value?.to !== state.to) {
    if (!state.from && !state.to) {
      model.value = null;
    } else {
      model.value = {
        from: state.from,
        to: state.to
      }
    }
  }
}

</script>